import SolutionCard from "../../reusables/SolutionCard";
import system from "../../../assets/images/solutions-icon/system_development.svg";

const SystemSolution = () => {
  return (
    <SolutionCard
      icon={system}
      title="Systems Development"
      subtitle="Custom-built systems that streamline operations and improve efficiency"
      ctaLink="/solutions/systems-development"
    />
  );
};
 
export default SystemSolution; 